export const DEFAULT_COVER_IMAGE = 'https://smile-bucket-2024.oss-cn-guangzhou.aliyuncs.com/lego/default-cover.png'
